// Libraries
import { Component } from "react";
import { Link } from "react-router-dom";

// Assets
import "./../assets/styles/SoF.css";


class SoF extends Component {
    render() {
        return(
            <div id="sof">
                <div className="bg-overlay">
                    <div className="container fadeIn">
                        <Link to="/about" className="closeDialog">Close</Link>
                        <div className="section s1">
                            <h1>My Statement of Faith</h1>
                            <p className="txtBody">
                                During my time of service in the Navy I endured my mother's struggle in battling cancer. 
                                As a result of complications arising from surgery to remove cancer, my mother passed away.
                                In the years following I sat in a moment of profound emptiness that permeated my life.
                                After years of struggling alone to fill the void, I found myself pulled towards a different direction in life. 
                                While studying at Washington State University in 2020, I became involved with a registered student organization by the name of
                                Chi Alpha: Christian Fellowship. It was here that I found a renewed hope in life through Jesus Christ. 
                                Since then, despite the struggles the world may have to offer, 
                                I've realized that through Jesus I've been able to find peace in knowing I am always cared for.
                                I don't consider myself religious, but as someone who loves and follows Jesus.
                                I believe that Jesus paid the price of sin for all people and rose from the grave so that all may have the eternal joy and peace that I now experience.
                                My continued journey in life has since been to discover what it means to love the God who continues to love me and to love those around me.
                                My hope is that anyone faced with similar despair may discover the same peace and joy.          
                            </p>
                            <p className="txtFtr">Glory be to God,</p>
                            <p className="txtFtr">Amen.</p>
                        </div>
                        <div className="section s2">
                        </div>
                    </div>
                </div>
            </div>
        );
    };
};

export default SoF;